// src/components/LanguageToggle.js
// Language picker — EN / ΕΛ / DE.
import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageToggle.css';

const OPTIONS = [
  { code: 'en', short: 'EN', label: 'English' },
  { code: 'el', short: 'ΕΛ', label: 'Ελληνικά' },
  { code: 'de', short: 'DE', label: 'Deutsch' },
];

export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const current = OPTIONS.find(o => o.code === lang) || OPTIONS[0];

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="lang-toggle-wrap" ref={wrapRef}>
      <button
        type="button"
        className={`lang-toggle lang-toggle--picker is-${current.code}`}
        onClick={() => setOpen(o => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={`Language: ${current.label}`}
        title={current.label}
      >
        <span className="lang-toggle-current">
          <span className="lang-toggle-current__code">{current.short}</span>
          <span className="lang-toggle-current__caret" aria-hidden="true">▾</span>
        </span>
      </button>

      {open && (
        <ul className="lang-toggle-menu" role="listbox" aria-label="Select language">
          {OPTIONS.map(opt => (
            <li key={opt.code} role="option" aria-selected={opt.code === lang}>
              <button
                type="button"
                className={`lang-toggle-menu__item ${opt.code === lang ? 'is-active' : ''}`}
                onClick={() => { setLang(opt.code); setOpen(false); }}
              >
                <span className="lang-toggle-menu__code">{opt.short}</span>
                <span className="lang-toggle-menu__label">{opt.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
